import { IRootState } from '../../../store'
import { IImmunizationOptionsState } from '../store/options.types'

export const getImmunizationOptionsSelector = (state: IRootState): IImmunizationOptionsState =>
  state.options.immunizationOptions
